var map = {
	"./el-GR/latest.json": [
		8438,
		438
	],
	"./en-US/latest.json": [
		7575,
		575
	],
	"./en/latest.json": [
		7046,
		46
	],
	"./es-ES/latest.json": [
		2468,
		468
	],
	"./es-US/latest.json": [
		6052,
		52
	],
	"./fi/latest.json": [
		8676,
		676
	],
	"./fil-PH/latest.json": [
		6601,
		601
	],
	"./fr-CA/latest.json": [
		3556,
		556
	],
	"./fr-FR/latest.json": [
		8368,
		368
	],
	"./it/latest.json": [
		6152,
		152
	],
	"./nl-NL/latest.json": [
		6648,
		648
	],
	"./pt-BR/latest.json": [
		1412,
		412
	],
	"./sv/latest.json": [
		9428,
		428
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5326;
module.exports = webpackAsyncContext;